import { Phone } from "lucide-react";
import { telHref, waHref, siteConfig } from "@/config/siteConfig";
import { trackEvent } from "@/lib/analytics";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const CallButton = ({ location, className = "", children, sub, testid }) => (
  <a
    href={telHref}
    data-testid={testid || `call-button-${location}`}
    onClick={() => trackEvent("phone_click", location)}
    className={`group inline-flex min-h-[48px] items-center justify-center gap-3 rounded-full bg-brand px-7 py-3.5 font-display text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-brand/30 transition-[transform,background-color,box-shadow] duration-200 hover:scale-[1.03] hover:bg-brand-dark hover:shadow-xl hover:shadow-brand/40 active:scale-95 ${className}`}
  >
    <Phone className="h-5 w-5 shrink-0" aria-hidden="true" />
    <span className="flex flex-col items-start leading-none">
      <span>{children || "Hemen Ara"}</span>
      {sub && <span className="mt-1 text-[11px] font-bold normal-case tracking-normal text-white/85">{sub}</span>}
    </span>
  </a>
);

// Varsayılan: konum gönderme butonu → whatsapp_location_click.
// Genel WhatsApp iletişim butonları için event="whatsapp_click" geçin.
export const WhatsAppButton = ({ location, className = "", children, sub, message, event = "whatsapp_location_click", testid }) => (
  <a
    href={waHref(message)}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid || `whatsapp-button-${location}`}
    onClick={() => trackEvent(event, location)}
    className={`group inline-flex min-h-[48px] items-center justify-center gap-3 rounded-full bg-wa px-7 py-3.5 font-display text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-wa/30 transition-[transform,background-color,box-shadow] duration-200 hover:scale-[1.03] hover:bg-wa-dark hover:shadow-xl hover:shadow-wa/40 active:scale-95 ${className}`}
  >
    <WhatsAppIcon className="h-5 w-5 shrink-0" />
    <span className="flex flex-col items-start leading-none">
      <span>{children || "WhatsApp'tan Konum Gönder"}</span>
      {sub && <span className="mt-1 text-[11px] font-bold normal-case tracking-normal text-white/85">{sub}</span>}
    </span>
  </a>
);

export { telHref, waHref, siteConfig };
